import Cookies from 'js-cookie';
import { IAccount } from 'utils/types/common';
import { kevinAuthAPI, kevinCommonAPI } from '../apis/config';
import { getServerUrl } from '../apis/config';
const USER_INFOR = 'loginAdmin';

export const cookieServices = {
  setUserInfo: (data: IAccount, isRemeber: boolean) => {
    const json = JSON.stringify(data);
    if (isRemeber) {
      // set expires time is 30 days.
      Cookies.set(USER_INFOR, json, { expires: 30 });
    } else {
      Cookies.set(USER_INFOR, json);
    }
  },
  getUserInfo: () => {
    if (Cookies.get(USER_INFOR)) {
      const json = Cookies.get(USER_INFOR);
      return JSON.parse(json);
    } else {
      return null;
    }
  },
  setDataSource: (data: 'live' | 'dev', userInfo: IAccount) => {
    const kevinUrl = getServerUrl();
    kevinAuthAPI.defaults.baseURL = kevinUrl;
    kevinAuthAPI.defaults.headers.common['x-jwt'] = userInfo!.accessToken;
    kevinCommonAPI.defaults.baseURL = kevinUrl;
  },
  getDataSource: () => {
    return Cookies.get('dataSource') || 'dev';
  },
  removeUserInfo: () => {
    Cookies.remove(USER_INFOR);
  },

  getUserRole: () => {
    if (Cookies.get(USER_INFOR)) {
      const user: IAccount = JSON.parse(Cookies.get(USER_INFOR));
      return user.role;
    } else {
      return null;
    }
  },
};
